import React, { Component } from 'react'
import {Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import Loader from "../Helper/Loader";

export class DoctorMaps extends Component {

    constructor(props){
        super(props);

        this.state = {
            center: {
                lat:0,
                lng:0
                },
            zoom: 12,
            places:[],
            errorMessage: "",
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
        }

      
    }

    componentDidMount(){
      let self = this;
      
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var state = {...self.state, 
              center:{
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
              },
              errorMessage:""
            }

            self.setState(state);


          }, function(e) {
            console.log(e);

            if(e.code === 1){
              self.setState({errorMessage:"Enable your location to see specialists near you"})
            }else{
              self.setState({errorMessage:"Error! Please try again or contact to us"})
            }
          });
        } else {
          // Browser doesn't support Geolocation
           self.setState({errorMessage:"Browser doesn't support Geolocation"})
        }
  }

    onMarkerClick = (props, marker, e) =>{
    

    const {google,place_id, map} = props;
    const {state} = this;
        let self = this;

        var request = {
          placeId: place_id
        };

       
        const service = new google.maps.places.PlacesService(map);
        
        service.getDetails(request, function(place, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              
              
                self.setState({...state,
                  selectedPlace: place,
                  activeMarker: marker,
                  showingInfoWindow: true
                });
            }
            else{
              console.log(status)
              self.setState({errorMessage:"Error! Apology for inconvenient "})
            }
          });
  }
 
    onMapClicked = (props) => {
      if (this.state.showingInfoWindow) {
        this.setState({
          showingInfoWindow: false,
          activeMarker: null
        })
      }
    };
    

  
    fetchPlaces(mapProps, map) {
        const {google} = mapProps;
        let self = this;

        var request = {
            // query: 'physical therapy near me',
            type: ['physiotherapist'],
            location: new google.maps.LatLng(self.state.center),
            radius:50000
          };

       
        const service = new google.maps.places.PlacesService(map);
        
        service.nearbySearch(request, function(results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              
              let state = {...self.state, places: results}
                self.setState(state);
            }
            else{
              console.log(status)
              self.setState({errorMessage:"Error! unable to get requested details"})
            }
          });
      }

  render() {
      const {google} = this.props;
      const {places, errorMessage, center, selectedPlace} = this.state;
    return (
        <div className="w-100 h-100 ">
            {errorMessage !== "" && <p className="text-center map-caption">{errorMessage}</p>}
            {errorMessage === "" && center.lat === 0 && center.lng === 0 && <div className="text-center map-caption"><Loader/></div>}
            {errorMessage === "" && center.lat !== 0 && center.lng !== 0 && <div><Map google={google}
                onReady={this.fetchPlaces.bind(this)}
                center={this.state.center}
                initialCenter={this.state.center}
                zoom={this.state.zoom}
                style={{width:"95%", height:"70%"}}
                onClick={this.onMapClicked}
                >
                    {/* <Marker label="M" onClick={this.onMarkerClick} position={this.state.center} onClick={this.onMarkerClick} name={'My Location'} /> */}


                   
                    {places.map((place,i) =>{
                      return <Marker key={i}  onClick={this.onMarkerClick}
                      title={place.name} place_id={place.place_id} 
                      // name={'SOMA'}
                      position={{lat: place.geometry.location.lat(), lng: place.geometry.location.lng()}} />
                    })}

              <InfoWindow
                marker={this.state.activeMarker}
                visible={this.state.showingInfoWindow}>
                  <div>
                    <h6>{selectedPlace.name}</h6>
                    <p>{selectedPlace.formatted_address}</p>
                    <span>{selectedPlace.formatted_phone_number}</span>
                    <a className="float-right" href={selectedPlace.url} target="_blank" rel="noopener noreferrer">View map</a>
                  </div>
              </InfoWindow>
                    
            </Map>
         
          </div>
          }

            
        </div>

    )
  }
}


export default GoogleApiWrapper((props) => ({
    apiKey: ('AIzaSyDY6lIrhpFofa9--XeN1eUvgCkBxVN0pOY'),
    LoadingContainer: Loader
  }))(DoctorMaps)
